import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { AuthService } from 'features/auth/service/service'

export type { UserContextRoles } from 'features/auth/service/service'
export { AuthService } from 'features/auth/service/service'

export function useAuthService(): AuthService {
  const client = useApiClient()
  return useMemo(() => new AuthService(client), [client])
}
